import React, { useState, createContext, useContext } from 'react';

type SelectedOriAliasContextType = {
    selectedOriAliasId?: string;
    setSelectedOriAliasId: (oriAliasId?: string) => void;
    shouldResetInitialValues: boolean;
    setShouldResetInitialValues: (shouldResetInitialValues: boolean) => void;
};

const SelectedOriAliasContext = createContext<SelectedOriAliasContextType | undefined>(undefined);

export function SelectedOriAliasProvider(props: {
    children: React.ReactElement;
}): React.ReactElement {
    const [selectedOriAliasId, setSelectedOriAliasId] = useState<string | undefined>();
    // indicate if dex form should reset to initial values after ori alias change.
    // it should be always 'true', unless dex form is querying an existing entity (dont set field values to form default, if form is prefilled with entity info).
    const [shouldResetInitialValues, setShouldResetInitialValues] = useState<boolean>(true);

    return (
        <SelectedOriAliasContext.Provider
            value={{
                selectedOriAliasId,
                setSelectedOriAliasId,
                shouldResetInitialValues,
                setShouldResetInitialValues,
            }}
        >
            {props.children}
        </SelectedOriAliasContext.Provider>
    );
}

export function useSelectedOriAlias(): SelectedOriAliasContextType {
    const selectedOriAlias = useContext(SelectedOriAliasContext);
    if (!selectedOriAlias) {
        throw new Error('Unexpectedly did not find selectedOriAlias');
    }
    return selectedOriAlias;
}
